import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Inject, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RfidCardDto } from '@dto/rfidCardDto';
import { UserDto } from '@dto/userDto';
import { User } from '@models/identity/user';
import { RfidCard } from '@models/rfidCard';
import { Tag } from '@models/tag';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RfidCardsService } from '@services/entity/rfidCards.service';
import { TagsService } from '@services/entity/tags.service';
import { UsersService } from '@services/entity/users.service';
import { ToastService } from '@services/toast/toast.service';
import { plainToClass } from 'class-transformer';
import { DeleteRFIDCardForCustomerDialogContentComponent } from '../../delete-rfid-card-for-customer-dialog-content/delete-rfid-card-for-customer-dialog-content.component';


@Component({
  selector: 'app-edit-rfid-card-dialog-content',
  templateUrl: './edit-rfid-card-dialog-content.component.html',
  styleUrls: ['./edit-rfid-card-dialog-content.component.scss']
})
export class EditRfidCardDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'EditRfidCardDialogContentComponent';
  spinner1 = 'editSpinner';

  public form: UntypedFormGroup;
  public formCreated: boolean;

  public rfidCard: RfidCardDto;
  public users: UserDto[];
  public tags: Tag[];

  public addTagRef: (name) => void;

  @Input() public rfidCardId: number;
  @Input() public customerId: number;
  @Input() public isOperatorView: boolean;
  public user: boolean = false;
  public customer: boolean = false;
  public operator: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    public activeModal: NgbActiveModal,
    public dialog: NgbModal,
    private rfidCardService: RfidCardsService,
    private spinner: NgxSpinnerService,
    private usersService: UsersService,
    private tagsService: TagsService,
    private toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
    this.addTagRef = this.addTagPromise.bind(this);

  }

  async ngOnInit() {
    super.ngOnInit();

    this.getRfidCard();
    this.getAdditionalEntities();
    this.getRoles();
    // this.checkDataReady();
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.customer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.operator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.user = true;
    }
  }

  getRfidCard() {
    this.rfidCardService.getRfidCard(this.rfidCardId).subscribe(result => {
      this.rfidCard = plainToClass(RfidCardDto, result);
      this.createForm();
    })
  }

  async getAdditionalEntities() {
    try {
      const usersPromise = this.isOperatorView ?
        this.usersService.getUsersOfCustomerAsync(this.customerId) :
        this.usersService.getUsersOfCurrentCustomerAsync();

      const tagsObservable = this.isOperatorView ?
        this.tagsService.getTagsOfCustomer(this.customerId) :
        this.tagsService.getEntities();

      this.users = await usersPromise;
      this.sortUsers();

      const tagsResult = await tagsObservable.toPromise();
      this.tags = this.sortTags(plainToClass(Tag, tagsResult));
    } catch (error) {
      console.error('Error fetching additional entities:', error);
    }
  }

  private sortUsers() {
    this.users.sort((a, b) => a.firstName.localeCompare(b.firstName));
  }

  private sortTags(tags: Tag[]) {
    return tags.sort((a, b) => a.name.localeCompare(b.name));
  }

  checkDataReady() {
    if (this.rfidCard && this.tags && this.users) {
      this.createForm();
    }
  }


  onDelete() {
    //this.spinner.show(this.spinner1);
    this.toastService.info($localize`:@@ChangeDialogSaveSuccessHeader:RFID-Karte wird gelöscht...`);
    this.rfidCardService.deleteEntity(this.rfidCard.id).subscribe(result => {
      this.activeModal.close();
      //this.spinner.hide(this.spinner1);
      this.toastService.success($localize`:@@ChangeDialogSaveSuccessHeader:RFID-Karte gelöscht.`, 3500, true);
    }, error => {
      this.toastService.error('RFID-Karte konnte nicht gelöscht werden.');
      //this.spinner.hide(this.spinner1);
    });
  }

  createForm() {
    this.form = new UntypedFormGroup({
      selectedUserId: new UntypedFormControl(this.rfidCard.userId),
      selectedTags: new UntypedFormControl(this.rfidCard.tags),
      note: new UntypedFormControl(this.rfidCard.note)
    });

    this.formCreated = true;
  }

  updateRfidCard() {
    //this.spinner.show(this.spinner1);
    this.toastService.info($localize`:@@ChangeDialogSaveSuccessHeader:Einstellungen werden gespeichert...`);

    this.rfidCard.userId = this.form.get('selectedUserId').value;
    this.rfidCard.tags = this.form.get('selectedTags').value;
    this.rfidCard.note = this.form.get('note').value;
    this.rfidCard.isOwnerChanged = this.form.get('selectedUserId').dirty;

    this.rfidCardService.updateEntity(this.rfidCard).subscribe(result => {
      //this.spinner.hide(this.spinner1);
      this.activeModal.close();
      this.toastService.success($localize`:@@ChangeDialogSaveSuccessHeader:Einstellungen gespeichert.`);
    }, error => {
      //this.spinner.hide(this.spinner1);
      this.toastService.error($localize`:@@ChangeDialogSaveSuccessHeader:Einstellungen konnten nicht gespeichert werden.`);

    });
  }


  addTagPromise(name) {
    return new Promise((resolve) => {
      //this.loading = true;
      setTimeout(() => {
        //this.loading = false;

        var tag = new Tag();
        tag.name = name;

        if (this.isOperatorView) {
          tag.customerId = this.customerId;
        }

        this.tagsService.createEntity(tag).subscribe(result => {
          this.getAdditionalEntities();
          resolve(result);
        }, error => {
          this.toastService.error('Neuer Tag konnte nicht gespeichert werden.');
        });

        //resolve(tag);
      }, 0);
    })
  }

}
